import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

/**
 * SafeResourceUrl per un iframe: l'URL se https, altrimenti about:blank.
 * Non restituisce mai null: senza il Sanitizer core registrato, un [src] di iframe
 * con un valore non SafeResourceUrl lancia NG0904 e interrompe il rendering della pagina.
 */
export function trustHttpsResourceUrl(sanitizer: DomSanitizer, value: unknown): SafeResourceUrl {
  return sanitizer.bypassSecurityTrustResourceUrl(toHttpsUrl(value) ?? 'about:blank');
}

/**
 * Restituisce l'URL (senza spazi) solo se e' https, altrimenti null.
 * Da usare prima di bypassSecurityTrustResourceUrl o Browser.open con URL che arrivano
 * da backend o push: "javascript:" in un iframe avrebbe accesso al bridge Capacitor.
 * Il parsing e' quello del browser, quindi le varianti offuscate (maiuscole, tab) sono
 * normalizzate prima del confronto.
 */
export function toHttpsUrl(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const url = value.trim();
  try {
    return new URL(url).protocol === 'https:' ? url : null;
  } catch {
    return null;
  }
}
